import JewelleryShowcase from "./editorial-catalogue";
import MagazineGrid from "./magazine-grid";
import ProductCatalog from "./product-catalog";
import EssencePerfume from "./essence-perfume";
import BestSeller from "./best-seller";
import LuxuryNoir from "./luxury-noir";
import NeonGlow from "./neon-glow";
import HeritageFrame from "./heritage-frame";
import GeoSplash from "./geo-splash";
import MinimalZen from "./minimal-zen";

export {
  JewelleryShowcase,
  MagazineGrid,
  ProductCatalog,
  EssencePerfume,
  BestSeller,
  LuxuryNoir,
  NeonGlow,
  HeritageFrame,
  GeoSplash,
  MinimalZen,
};

export const LAYOUTS = {
  "editorial-catalogue": JewelleryShowcase,
  "magazine-grid":       MagazineGrid,
  "product-catalog":     ProductCatalog,
  "essence-perfume":     EssencePerfume,
  "best-seller":         BestSeller,
  "luxury-noir":         LuxuryNoir,
  "neon-glow":           NeonGlow,
  "heritage-frame":      HeritageFrame,
  "geo-splash":          GeoSplash,
  "minimal-zen":         MinimalZen,
};

export default LAYOUTS;
